/*
 * --------------------------------------------------------------------------- *
 * File: addressfield.js                                                       *
 * Project: web                                                                *
 * Created Date: 29 Oct 2022                                                   *
 * Author: Vikas K Solegaonkar (vikas.solegaonkar@gmail.com)                   *
 * Copyright (c) 2022 Vikas K Solegaonkar                                      *
 * https://solegaonkar.com                                                     *
 *                                                                             *
 * Last Modified: Sat Oct 29 2022                                              *
 * Modified By: Vikas K Solegaonkar                                            *
 *                                                                             *
 * HISTORY:                                                                    *
 * --------------------------------------------------------------------------- *
 * Date         By     Comments                                                *
 * --------------------------------------------------------------------------- *
 */



import React, { useState } from "react";
import GooglePlacesAutocomplete from "react-google-places-autocomplete";

function AddressField(props) {
  const [value, setValue] = useState(null);

  const onChange = (e) => {
    if (props && props.onChange) {
      props.onChange(e);
    }
  };

  return (
    <div className={props.type.divCss}>
      <div className="field-title">{props.type.fieldTitle}</div>
      <GooglePlacesAutocomplete
        apiKey="AIzaSyB9QXEsJL9b4atppWRnp9kibCvyGuWDZuM"
        selectProps={{
          value,
          onChange: setValue,
        }}
      />

      {/* <Autocomplete
        apiKey="AIzaSyB9QXEsJL9b4atppWRnp9kibCvyGuWDZuM"
        onPlaceSelected={(place) => console.log(place)}
      /> */}
    </div>
  );
}

export default AddressField;
